/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './Top.css';
import WhereField from './partials/WhereField';
import Ranking from './partials/Ranking';

import {
  getRanking
} from '../actions';


class Top extends OzComponent {

  static need = [
    ['ranking', getRanking],
  ];

  state = {};

  componentDidMount() {
    try {
      scroll(0, 0);
    } catch (e) {}
    this.props.getRanking(null, { background: true, silent: true });
  }

  refresh(params) {
    this.props.getRanking(null, { background: true }, params);
  }

  render() {
    console.log('RANKING', this.props.ranking);
    let ranking = this.props.ranking;

    return (
      <Wrapper className="Top" title="Top Escape Rooms">
        <div className="blurb">
          <p>EscapeSpy ranks the top escape rooms around the world based on ratings from our users. These ratings are highly detailed, including a score from 0-100, for a precise and accurate ranking.</p>
        </div>

        {ranking && <Ranking
         isRollup
         reviews={{items: ranking.ranking}}
         onRefresh={(params) => this.refresh(params)}
         />}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    ranking: state.get.ranking,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getRanking,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Top);



/** WEBPACK FOOTER **
 ** ./src/components/Top.js
 **/